import React from 'react';
import useHelpers from 'hooks/helpers';
import { standardFormat } from 'constants/dateFormats';

type Props = {
  propertyName: string;
  selectedShareclass: {
    currency?: string;
    dailyPrice?: string;
    date?: string;
    isin?: string;
    priceChange?: string;
    shareclassID?: string;
    shareclassName?: string;
    url?: string;
    priceDate?: string;
    [key: string]: any;
  };
};

const FundsPrice: React.FC<Props> = ({ selectedShareclass, propertyName }) => {
  const { formatCurrency, localizeDate } = useHelpers();
  const price: number = formatCurrency(
    selectedShareclass[propertyName],
    selectedShareclass.currency
  );
  const date = localizeDate(
    selectedShareclass.date || selectedShareclass.priceDate,
    standardFormat
  ) as string;

  return price ? (
    <>
      <div className="h6">{price}</div>
      {date && <div className="body-small mt-1/2">{date}</div>}
    </>
  ) : (
    <div className="h6">--</div>
  );
};

export default FundsPrice;
